import {
  AppBar,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  tableCellClasses,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import Select from "react-select";
import customStyles from "app/shared-components/SelectCustomStyle";
import { useState } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import { useEffect } from "react";
import { checkSpecialChar, checkString } from "../../utilities/FormValidation";
import { isEqual } from "lodash";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
  },
}));
const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  "& input": {
    padding: "10px 14px",
    textAlign: "center",
  },
}));
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "rgba(32, 35, 38)",
    color: theme.palette.common.white,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({}));

const PaymentTermsForm = (props) => {
  const {
    addOpen,
    editRowOpen,
    viewRowOpen,
    handleAdd,
    handleEdit,
    handleClose,
    addRow,
    editRow,
    viewRow,
  } = props;

  const [values, setValues] = useState({
    code: "",
    paymentCondition: "",
  });
  const [total, setTotal] = useState(0);
  const [addDisable, setAddDisable] = useState(false);
  const [totalValid, setTotalValid] = useState(false);
  const [saveDisable, setSaveDisable] = useState(false);
  const [validError, setValidError] = useState({});
  const [formValues, setFormValues] = useState([
    {
      id: null,
      day: "",
      type: {},
      rate: "",
      description: "",
      createdBy: null,
      createdAt: null,
      updatedBy: null,
      updatedAt: null,
    },
  ]);
  // const [formValuesChanged, setFormValuesChanged] = useState(false);
  // const [oldFormValues, setOldFormValues] = useState();
  // const [oldValues, setOldValues] = useState();
  const [formChanged, setFormChanged] = useState(false);
  const [originalFormValues, setOriginalFormValues] = useState([]);
  const options = [
    { value: "PROFORMA INVOICE", label: "PROFORMA INVOICE" },
    { value: "INVOICE/BL DATE", label: "INVOICE/BL DATE" },
    { value: "DELIVERY DATE", label: "DELIVERY DATE" },
  ];

  const handleChange = (i, e, field) => {
    let newFormValues = [...formValues];
    const inputValue = e.target.value.replace(/\D/g, '');

    if(field === 'rate') {
      const intValue = parseInt(inputValue, 10);
      if (!isNaN(intValue) && intValue > 0) {
        newFormValues[i][e.target.name] = intValue;
      } else {
        newFormValues[i][e.target.name] = '';
      }
    } else if(field === 'day') {
      newFormValues[i][e.target.name] = inputValue;
    } else {
      newFormValues[i][e.target.name] = e.target.value;
    }
    const isFormChanged = !isEqual(newFormValues[i], originalFormValues[i]);
    console.log('isFormChanged', isFormChanged)
    setFormChanged(isFormChanged)
    setFormValues(newFormValues);
    // setFormChanged(true);
  };

  const handleSelectChange = (i, e) => {
    setFormChanged(true);
    let newFormValues = [...formValues];
    newFormValues[i]["type"] = e;

    const isFormChanged = !isEqual(newFormValues[i], originalFormValues[i]);
    setFormChanged(isFormChanged)
    setFormValues(newFormValues);

    // const isAllSameAsOriginal = newFormValues.every((value, index) => isEqual(value, originalFormValues[index]));
    // setFormChanged(!isAllSameAsOriginal);

    // setFormValuesChanged(true);
  };

  const handleValueChange = (event) => {
    setValues((prev) => ({ ...prev, [event.target.name]: event.target.value }));

    const isFormChanged = event.target.value !== originalFormValues[event.target.name];
    setFormChanged(isFormChanged);
    // setFormValuesChanged(true);
  };

  const { code, paymentCondition } = values;

  let addFormFields = () => {
    setFormValues([
      ...formValues,
      {
        id: null,
        day: "",
        type: {},
        rate: "",
        description: "",
        createdBy: null,
        createdAt: null,
        updatedBy: null,
        updatedAt: null,
      },
    ]);
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  useEffect(() => {
    let sum = 0;
    for (let index = 0; index < formValues.length; index++) {
      const element = formValues[index].rate || 0;
      sum = sum + parseInt(element);
    }
    const checkForm = formValues.every(
      (item) => item.type && item.day && item.rate
    );
    setTotal(sum);
    setAddDisable(sum >= 100);
    if (sum > 100) {
      setTotalValid(true);
      setSaveDisable(true);
    } else if (
      sum !== 100 ||
      !values.code ||
      !values.paymentCondition ||
      !checkForm
    ) {
      setSaveDisable(true);
    } else {
      setTotalValid(false);
      setSaveDisable(false);
    }



    // const isFormValuesChanged = formValuesChanged;
    // const isFormValuesSameAsOld = JSON.stringify(formValues) === JSON.stringify(oldFormValues);
    // // // console.log('isFormValuesSameAsOld', isFormValuesSameAsOld)
    // const isValuesSameAsOld = JSON.stringify(values) === JSON.stringify(oldValues);
    // // // console.log('isValuesSameAsOld', isValuesSameAsOld)
    // // // console.log('setSaveDisable', isFormValuesSameAsOld || isValuesSameAsOld)
    // setSaveDisable(isFormValuesSameAsOld || isValuesSameAsOld);
  }, [formValues, values]);



  useEffect(() => {
    if (addOpen) {
      setValues((prev) => ({
        ...prev,
        code: "",
        paymentCondition: "",
      }));
      setFormValues([
        {
          id: null,
          day: "",
          type: {},
          rate: "",
          description: "",
          createdBy: null,
          createdAt: null,
          updatedBy: null,
          updatedAt: null,
        },
      ]);
    }
  }, [addOpen]);

  useEffect(() => {
    if (editRowOpen) {
      setFormChanged(false);
      setFormValues(
        editRow.node?.data?.paymentInstallmentList.map((item) => ({
          ...item,
          type: { value: item.type, label: item.type },
        })) || []
      );
      setValues((prev) => ({
        ...prev,
        code: editRow.node?.data?.code,
        paymentCondition: editRow.node?.data?.paymentCondition,
        paymentInstallmentList: formValues,
      }));
      setOriginalFormValues([...editRow.node.data.paymentInstallmentList])
      // setOldFormValues(formValues);
      // setOldValues(values);
    }
  }, [editRowOpen]);

  useEffect(() => {
    if (viewRowOpen) {
      setFormValues(
        viewRow.node?.data?.paymentInstallmentList.map((item) => ({
          ...item,
          type: { value: item.type, label: item.type },
        })) || []
      );
      setValues((prev) => ({
        ...prev,
        code: viewRow.node?.data?.code,
        paymentCondition: viewRow.node?.data?.paymentCondition,
        paymentInstallmentList: formValues,
      }));
    }
  }, [viewRowOpen]);

  return (
    <>
      <Dialog
        open={addOpen || editRowOpen || viewRowOpen}
        fullWidth
        maxWidth="md"
        component="form"
      >
        <AppBar position="static">
          <Toolbar className="flex w-full justify-between">
            <Typography variant="subtitle1" color="inherit">
              {editRowOpen ? 'Update' : 'Add'} Payment Condition
            </Typography>
            <Button onClick={handleClose}>
              <FuseSvgIcon>heroicons-solid:x</FuseSvgIcon>
            </Button>
          </Toolbar>
        </AppBar>
        <form>
          <DialogContent classes={{ root: "p-16 pb-0 sm:p-24 sm:pb-0" }}>
            <Grid container>
              <Grid xs={12} item>
                <div className="flex container">
                  <FormControl className="flex flex-row mb-16">
                    <div className="mr-16">
                      <label>Code</label>
                      <StyledTextField
                        type="text"
                        variant="outlined"
                        fullWidth
                        name="code"
                        value={code}
                        onChange={handleValueChange}
                        disabled={viewRowOpen}
                      />
                    </div>
                    <div className="mr-16">
                      <label>Payment Condition</label>
                      <StyledTextField
                        type="text"
                        variant="outlined"
                        fullWidth
                        name="paymentCondition"
                        value={paymentCondition}
                        onChange={handleValueChange}
                        disabled={viewRowOpen}
                      />
                    </div>
                  </FormControl>
                </div>
              </Grid>
              <Grid xs={12} item>
                <label>Installments</label>
                <TableContainer className="mt-10 mb-16" component={Paper} sx={{ maxHeight: 400, border: '1px solid rgba(255, 255, 255, 0.23)' }}>
                  <Table sx={{ minWidth: 650 }} stickyHeader>
                    <TableHead>
                      <TableRow>
                        <StyledTableCell>Day</StyledTableCell>
                        <StyledTableCell>Based on</StyledTableCell>
                        <StyledTableCell align="center">Rate</StyledTableCell>
                        <StyledTableCell>Description</StyledTableCell>
                        <StyledTableCell>&nbsp;</StyledTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formValues.map((element, index) => (
                        <StyledTableRow key={index}>
                          <StyledTableCell component="th" scope="row">
                            <StyledTextField
                              type="text"
                              name="day"
                              variant="outlined"
                              value={element.day}
                              onChange={(e) => handleChange(index, e, 'day')}
                              sx={{ maxWidth: "60px" }}
                              min="1"
                              step="1"
                              className="input-number"
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <div style={{ width: "230px" }}>
                              <Select
                                name="type"
                                value={element.type}
                                options={options}
                                onChange={(e) => handleSelectChange(index, e)}
                                styles={customStyles()}
                              />
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="center">
                            <StyledOutlinedInput
                              type="text"
                              name="rate"
                              sx={{ maxWidth: "100px" }}
                              value={element.rate}
                              onChange={(e) => handleChange(index, e, 'rate')}
                              className="text-center"
                              endAdornment={
                                <InputAdornment position="end">
                                  %
                                </InputAdornment>
                              }
                            />
                          </StyledTableCell>
                          <StyledTableCell>
                            <StyledTextField
                              type="text"
                              name="description"
                              variant="outlined"
                              fullWidth
                              value={element.description}
                              onChange={(e) => handleChange(index, e, 'description')}
                            />
                          </StyledTableCell>
                          <StyledTableCell align="right">
                            {index ? (
                              <IconButton
                                color="secondary"
                                aria-label="upload picture"
                                component="label"
                                onClick={() => removeFormFields(index)}
                              >
                                <FuseSvgIcon>heroicons-outline:x</FuseSvgIcon>
                              </IconButton>
                            ) : null}
                          </StyledTableCell>
                        </StyledTableRow>
                      ))}
                    </TableBody>
                    <TableFooter>
                      <StyledTableRow>
                        <StyledTableCell colSpan={2}>
                          <Button
                            variant="contained"
                            color="primary"
                            type="button"
                            disabled={addDisable}
                            onClick={() => addFormFields()}
                          >
                            Add Installment
                          </Button>
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          Total
                          <Typography
                            variant="body1"
                            className="text-lg font-medium leading-6"
                          >
                            {total}%
                          </Typography>
                        </StyledTableCell>
                        <StyledTableCell colSpan={2}>
                          {totalValid && (
                            <Typography sx={{ color: "error.main" }}>
                              Total Rate value cannot exceed 100.00%.
                            </Typography>
                          )}
                        </StyledTableCell>
                      </StyledTableRow>
                    </TableFooter>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions
            sx={{ background: "#373c42" }}
            className="justify-between px-16 sm:px-16"
          >
            <Box>&nbsp;</Box>
            <Button
              variant="contained"
              color="primary"
              type="button"
              disabled={saveDisable || !formChanged}
              onClick={() => {
                if (addOpen) {
                  handleAdd(addRow, values, formValues);
                } else if (editRowOpen) {
                  handleEdit(editRow, values, formValues);
                }
              }}
            >
              Save & Exit
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default PaymentTermsForm;
